import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { NvDesignLibraryModule } from 'Src/nvps-libraries/design/nv-design-library.module';

@NgModule({
  imports: [CommonModule, NvDesignLibraryModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class FixedToInfiniteViewModule {
  /** */
}
